<template>
  <el-row type="flex" align="middle" class="toolbar">
    <el-col class="title">
      <slot name="title"><i :class="icon"></i> {{ title }}</slot>
    </el-col>
    <el-col class="tools">
      <slot name="tools">
        <slot name="custom-tools-pre"></slot>
        <el-button
          type="primary"
          size="mini"
          v-tooltip="$t('vtool.deploy')"
          @click="openDeployModal"
          v-if="deploy && showDeploy"
          :disabled="disableDeploy"
          >Desplegar</el-button
        >
        <el-button
          type="primary"
          size="mini"
          v-tooltip="$t('vtool.confirmDeploy')"
          @click="openConfirmDeployModal"
          v-if="confirmDeploy && showConfirmDeploy"
          :disabled="disableConfirmDeploy"
          >Confirmar Despliegue</el-button
        >
        <el-button
          type="primary"
          size="mini"
          v-tooltip="$t('vtool.rollbackDeploy')"
          @click="openRollbackDeployModal"
          v-if="showRollbackDeploy"
          :disabled="disableRollbackDeploy"
          >Deshacer Despliegue</el-button
        >
        <el-button
          type="primary"
          size="mini"
          v-tooltip="$t('vtool.activeProcess')"
          @click="openActiveProcessModal"
          v-if="showActiveProcess"
          :disabled="disableActiveProcess"
          >Activar</el-button
        >
        <el-button
          type="primary"
          size="mini"
          icon="fas fa-plus"
          v-tooltip="$t('vtool.create')"
          @click="goNext"
          v-if="create && $getPermission('crear', to ? to.name : $route.name)"
        ></el-button>
        <el-button
          type="primary"
          size="mini"
          icon="fas fa-save"
          v-tooltip="$t('vtool.save')"
          @click="doSave"
          v-if="
            save &&
            ($getPermission('crear', $route.name) ||
              $getPermission('modificar', $route.name))
          "
          :disabled="disableSave"
        ></el-button>

        <!--    <el-button type="primary" size="mini" icon="fas fa-save" v-tooltip="$t('vtool.save')" @click="doSave" v-if="save && ($getPermission('crear',to ? to.name : $route.name) || $getPermission('modificar', to ? to.name : $route.name))" :disabled=disableSave></el-button>-->

        <el-button
          type="danger"
          size="mini"
          icon="fas fa-arrow-left"
          v-tooltip="$t('vtool.back')"
          @click="goBack"
          v-if="back"
        ></el-button>
        <el-button
          type="default"
          size="mini"
          icon="fas fa-minus"
          v-tooltip="$t('vtool.clean')"
          @click="doCancel"
          v-if="cancel"
        ></el-button>
        <slot name="custom-tools-post"></slot>
      </slot>
    </el-col>
  </el-row>
</template>

<style lang="scss">
.toolbar {
  @apply w-full border-b border-grey-light pb-2 mb-2;

  .title {
    @apply flex-1 text-base text-black font-semibold uppercase;
  }

  @media screen and (max-width: 300px) {
    .title {
      font-size: 1rem !important;
    }
  }

  .tools {
    @apply w-auto;
  }
}
</style>

<script>
export default {
  props: {
    to: {
      type: Object,
      required: false,
      default: null,
    },
    icon: {
      type: String,
      required: false,
      default: "",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    create: {
      type: Boolean,
      required: false,
      default: false,
    },
    save: {
      type: Boolean,
      required: false,
      default: false,
    },
    deploy: {
      type: Boolean,
      required: false,
      default: false,
    },
    confirmDeploy: {
      type: Boolean,
      required: false,
      default: false,
    },
    rollbackDeploy: {
      type: Boolean,
      required: false,
      default: false,
    },
    activeProcess: {
      type: Boolean,
      required: false,
      default: false,
    },
    back: {
      type: Boolean,
      required: false,
      default: false,
    },
    cancel: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableSave: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableDeploy: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableConfirmDeploy: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableRollbackDeploy: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableActiveProcess: {
      type: Boolean,
      required: false,
      default: false,
    },
    showDeploy: {
      type: Boolean,
      required: false,
      default: false,
    },
    showConfirmDeploy: {
      type: Boolean,
      required: false,
      default: false,
    },
    showRollbackDeploy: {
      type: Boolean,
      required: false,
      default: false,
    },
    showActiveProcess: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  methods: {
    goNext() {
      this.$router.push(this.to || `${this.$route.path}/nuevo`);
    },
    goBack() {
      this.$router.go(-1);
    },
    doSave() {
      this.$emit("save");
    },
    doCancel() {
      this.$emit("cancel");
    },
    openDeployModal() {
      this.$emit("open-deploy");
    },
    openConfirmDeployModal() {
      this.$emit("open-confirmDeploy");
    },
    openRollbackDeployModal() {
      this.$emit("open-rollbackDeployment");
    },
    openActiveProcessModal() {
      this.$emit("open-activeProcess");
    },
  },
};
</script>
